/**
 * @module タイムパーサーユーティリティ
 */
import moment from 'moment';

/**
 * 日時オブジェクト変換
 * @param {String} date 日時文字列
 * @returns object 年月日時間曜日
 */
const timeParser = (date) => {
  const tempDate = new Date(moment(date, 'YYYYMMDDThh:mm:ss'));
  const dayOfWeek = () => {
    switch (tempDate.getDay()) {
      case 0:
        return '日';
      case 1:
        return '月';
      case 2:
        return '火';
      case 3:
        return '水';
      case 4:
        return '木';
      case 5:
        return '金';
      case 6:
        return '土';
    }
  };
  return {
    year: tempDate.getFullYear(),
    month: `0${tempDate.getMonth() + 1}`.slice(-2),
    day: `0${tempDate.getDate()}`.slice(-2),
    hour: `0${tempDate.getHours()}`.slice(-2),
    minutes: `0${tempDate.getMinutes()}`.slice(-2),
    seconds: `0${tempDate.getSeconds()}`.slice(-2),
    dayOfWeek: dayOfWeek(),
  };
};

export default timeParser;
